export function deepcopy<T>(o: T): T {
  if (Array.isArray(o)) {
    return o.map((e: any) => deepcopy(e)) as any as T
  }
  if (typeof o === 'object') {
    if (o == null) {
      return null as any as T
    } else {
      const o2 = {} as any
      // tslint:disable-next-line:forin
      for (const k in o) {
        o2[k] = deepcopy(o[k])
      }
      return o2
    }
  }
  return o
}

export function deepEqual<T>(a: T, b: T): boolean {
  if (Array.isArray(a)) {
    if (Array.isArray(b)) {
      return a.length === b.length && a.every((c, i) => deepEqual(c, (b as any)[i]))
    }
    return false
  }
  if (typeof a === 'object') {
    if (a === null) {
      return a === b
    }
    return Object.keys(a).every((k) => deepEqual((a as any)[k], (b as any)[k]))
  }
  return a === b
}
